import "./utils/sentry";
import React from 'react';
import * as Sentry from "@sentry/react";
import App from './App';
import 'translation';
import { ProvideAuth } from 'system/APIAuth';
import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  // https://docs.sentry.io/platforms/javascript/guides/react/
  <Sentry.ErrorBoundary >
    <React.Fragment>
      {/* <React.StrictMode> */}
        <ProvideAuth>
          <App />
        </ProvideAuth>
      {/* </React.StrictMode> */}
    </React.Fragment>
  </Sentry.ErrorBoundary>
);
